module.exports = __webpack_public_path__ + "static/media/ljummen.cf71255e.mp3";